import { useCallback } from 'react';
import { Switch, SwitchProps } from 'tdesign-react';


export const NumSwitch: React.FC<
{
  value: 0 | 1;
  onChange: (value: 0 | 1) => void;
} & SwitchProps> = (props) => {
  const { value, onChange } = props;

  const handleChange = useCallback(() => {
    onChange(value === 0 ? 1 : 0);
  }, [value]);

  return <Switch {...props} value={!Boolean(value)} onChange={handleChange} />;
};
